import React, { useEffect, useRef, useState } from "react";
import { 
  Tag, 
  Box, 
  Grid, 
  IconButton, 
  Button as ButtonChakra,
  Image, 
  Text,         
  InputGroup, 
  InputLeftAddon, 
  Stack,
  Input, 
  Select, 
  Textarea, 
  useDisclosure,
  Wrap, 
  WrapItem,
  Center,
  useMediaQuery ,
  Alert,
  AlertIcon
} from "@chakra-ui/react";
import { AddIcon, CopyIcon } from "@chakra-ui/icons";
import Highlighter from 'react-highlight-words';
// Ant Design imports
import { 
  FloatButton, Card,
  Switch, 
  Space,
  Table,
  Tag as AntTag,
  Button,
  Modal as AntModal,
  Form,
  Input as AntInput,
  Select as AntSelect,
  InputNumber,
  Checkbox,
  message,
  Empty,Menu,
  Spin
} from 'antd';
import { 
  CheckOutlined, 
  CloseOutlined,
  EditOutlined,
  WhatsAppOutlined,SearchOutlined ,
  CopyOutlined,
  ExclamationCircleOutlined,
  ReloadOutlined,  RightOutlined,
  DownOutlined

} from '@ant-design/icons';

import { FaTimes, FaCheck } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { getNombres, getNotes, createNotes, updateNotes } from "../redux/notes/note_actions";
import { getDestinos } from "../redux/destinos/destino_actions";
import { getEstados } from "../redux/estados/estado_actions";

import { Toaster } from 'react-hot-toast';
import { SelectFiltros } from "../components/Notes/SelectFiltros";
import NoteCard from "../components/Notes/NoteCard/NoteCard";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";

const { Column } = Table;
const { Option } = AntSelect;
const { TextArea: AntTextArea } = AntInput;

export default function Notespage() {
  const dispatch = useDispatch();
  // const { error, data, datanombres } = useSelector((state) => state.noteReducer);
  // const { datadestino } = useSelector((state) => state.destinoReducer);
  // const { dataestado } = useSelector((state) => state.estadoReducer);

  const [contextMenu, setContextMenu] = useState({ visible: false, x: 0, y: 0, record: null });  

  const [searchGlobal, setSearchGlobal] = useState('');
  const searchInputRef = useRef(null);

  const [doubleClickModal, setDoubleClickModal] = useState(false);
  const [selectedNote, setSelectedNote] = useState(null);
  const [newEstado, setNewEstado] = useState('');  

  const noteState = useSelector((state) => state.noteReducer);
  const destinoState = useSelector((state) => state.destinoReducer);
  const estadoState = useSelector((state) => state.estadoReducer);
  
  
  const { error, data, datanombres, loading } = noteState;
  const { datadestino, loadingdestino, errordestino } = destinoState;
  const { dataestado, loadingestado, errorestado } = estadoState;
  
  const [notes, setNotes] = useState([]);
  const [nombres, setNombres] = useState([]);
  const [isMobile] = useMediaQuery("(max-width: 768px)");
  
  // Modal states
  const { isOpen, onOpen, onClose } = useDisclosure();
  const modalEdit = useDisclosure();
  
  // Form states
  const [title, setTitle] = useState("");
  const [documento, setDocumento] = useState("");
  const [telefono, setTelefono] = useState("");
  const [correoelectronico, setCorreoElectronico] = useState("");
  const [referencia, setReferencia] = useState("");
  const [estado, setEstado] = useState("Pendiente");
  const [pagado, setPagado] = useState(false);
  const [destino, setDestino] = useState("");
  const [body, setBody] = useState("");
  const [notasinternas, setNotasInternas] = useState("");
  
  // Edit states
  const [tempTitle, setTitle2] = useState("");
  const [tempDocumento, setDocumento2] = useState("");
  const [tempTelefono, setTelefono2] = useState("");
  const [tempCorreoElectronico, setCorreoElectronico2] = useState("");
  const [tempReferencia, setReferencia2] = useState("");
  const [tempEstado, setEstado2] = useState("");
  const [tempDestino, setDestino2] = useState("");
  const [tempBody, setBody2] = useState("");
  const [tempNotasInternas, setNotasInternas2] = useState("");
  const [tempPagado, setPagado2] = useState(false);
  const [tempID, setId] = useState("");
  
  // Filter states
  const [filtroestados, setFiltroEstados] = useState([]);
  const [filtrodestinos, setFiltroDestinos] = useState([]);
  const [filtrosEdicion, setFiltrosEdicion] = useState('');
  const [verEtiquetas, setVerEtiquetas] = useState(true);
  const [pending, setPending] = useState(true);

  // Ant Design Modal
  const [isAntModalOpen, setIsAntModalOpen] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);

  // Debug completo del estado de Redux
  console.log("=== REDUX STATE DEBUG ===");
  console.log("Note State:", noteState);
  console.log("Destino State:", destinoState);
  console.log("Estado State:", estadoState);
  console.log("=========================");

  // Cargar datos iniciales
  useEffect(() => {             
    console.log("🔃 Cargando datos iniciales...");
    
    const loadInitialData = async () => {
      try {
        console.log("📤 Dispatch getNotes...");
        await dispatch(getNotes());
        
        console.log("📤 Dispatch getDestinos...");
        await dispatch(getDestinos());
        
        console.log("📤 Dispatch getEstados...");
        await dispatch(getEstados());
        
        console.log("✅ Todos los dispatches completados");
      } catch (error) {
        console.error("❌ Error cargando datos iniciales:", error);
      }
    };

    loadInitialData();
  }, [dispatch]);     

  // Aplicar filtros
  useEffect(() => {     
    console.log("🎯 Aplicando filtros:", { filtroestados, filtrodestinos });
    
    // Convertir arrays de strings a arrays de objetos (formato que espera el backend)
    const filtrosDestinosObj = filtrodestinos.map(descripcion => ({ descripcion }));
    const filtrosEstadosObj = filtroestados.map(descripcion => ({ descripcion }));
    
    const filtros = {
      filtroestados: JSON.stringify(filtrosEstadosObj),
      filtrodestinos: JSON.stringify(filtrosDestinosObj),           
    };      
    console.log("📤 Enviando filtros al backend:", filtros);
    
    setFiltrosEdicion(filtros);
    dispatch(getNotes(filtros));
    
  }, [filtroestados, filtrodestinos, dispatch]);
  
  useEffect(() => {
    console.log("🔍 Estado actual de Redux:", {
      notesCount: data?.length || 0,
      filtrosAplicados: filtrosEdicion,
      filtrosActuales: { filtroestados, filtrodestinos }
    });
  }, [data, filtrosEdicion, filtroestados, filtrodestinos]);

  // Actualizar notas cuando cambian los datos
  useEffect(() => {
    console.log("🔄 Actualizando notas, data:", data);
    console.log("🔍 Detalle de data:", {
      tipo: typeof data,
      esArray: Array.isArray(data),
      longitud: data?.length,
      primerElemento: data?.[0]
    });
    
    if (data && Array.isArray(data) && data.length > 0) {
      console.log("📝 Notas cargadas:", data.length, "elementos");
      console.log("📋 Primer elemento:", data[0]);
      setNotes(data);        
      setPending(false);
    } else if (data && Array.isArray(data)) {
      console.log("📭 Array de notas está vacío - VERIFICAR FILTROS EN BACKEND");
      console.log("🎯 Filtros aplicados:", filtrosEdicion);
      setNotes([]);
      setPending(false);
    } else {
      console.log("❓ Data no es un array válido:", data);
      setNotes([]);
      setPending(false);
    }
  }, [data]);

  // useEffect(() => {
  //   if (datanombres) {
  //     setNombres(datanombres);        
  //   }
  // }, [datanombres]);

  const createNote = () => {
    dispatch(createNotes({
      title, 
      documento, 
      telefono, 
      correoelectronico, 
      referencia, 
      estado, 
      destino, 
      pagado: pagado ? 1 : 0, 
      body, 
      notasinternas
    }));
    onClose();
    resetForm();
  };


    // Preparar datos para la tabla
  const tableData = Array.isArray(data) && data.length > 0 ? data : [];

  const duplicateNote = (record) => {
    const { id, createdAt, updatedAt, ...noteData } = record;
    
    dispatch(createNotes({
      ...noteData,
      title: `${noteData.title} (Copia)`, // Opcional: agregar indicador de copia
      // createdAt y updatedAt se generarán automáticamente
    }));
    
    message.success('Nota duplicada correctamente');
  };  

  const handleContextMenu = (event, record) => {
    event.preventDefault();
    
    const menuWidth = 160; // Ancho aproximado del menú
    const menuHeight = 140; // Alto aproximado del menú
    
    // Obtener dimensiones de la ventana
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    
    // Calcular posición ajustada
    let adjustedX = event.clientX;
    let adjustedY = event.clientY;
    
    // Ajustar posición horizontal si se sale por la derecha
    if (event.clientX + menuWidth > windowWidth) {
      adjustedX = event.clientX - menuWidth;
    }
    
    // Ajustar posición vertical si se sale por abajo
    if (event.clientY + menuHeight > windowHeight) {
      adjustedY = event.clientY - menuHeight;
    }
    
    setContextMenu({
      visible: true,
      x: adjustedX,
      y: adjustedY,
      record: record
    });
  };

  // Cerrar menú contextual
  const handleCloseContextMenu = () => {
    setContextMenu({ visible: false, x: 0, y: 0, record: null });
  };  


  // Función para doble click en el ESTADO (modal rápido)
  const handleEstadoDoubleClick = (record) => {
    console.log("🔄 Doble click en estado - Cambio rápido");
    setSelectedNote(record);
    setNewEstado(record.estado || '');
    setDoubleClickModal(true);
  };

  // Función para doble click en la FILA (edición completa)
  const handleRowDoubleClick = (record) => {
    console.log("📝 Doble click en fila - Editar completo");
    handleEdit(record); // Esta función ya existe para abrir edición completa
  };

  // Función para actualizar solo el estado
  const updateEstado = () => {
    if (!selectedNote) return;
    
    dispatch(updateNotes(selectedNote.id, {
      ...selectedNote,
      estado: newEstado
    }, filtrosEdicion));
    
    setDoubleClickModal(false);
    setSelectedNote(null);
    setNewEstado('');
  };

  const updateNote = () => {
    dispatch(updateNotes(tempID, {
      title: tempTitle, 
      documento: tempDocumento, 
      telefono: tempTelefono, 
      correoelectronico: tempCorreoElectronico, 
      referencia: tempReferencia, 
      estado: tempEstado, 
      destino: tempDestino, 
      pagado: tempPagado ? 1 : 0, 
      body: tempBody, 
      notasinternas: tempNotasInternas
    }, filtrosEdicion));
    modalEdit.onClose();
    setIsAntModalOpen(false);
  };

  const resetForm = () => {
    setTitle("");
    setDocumento("");
    setTelefono("");
    setCorreoElectronico("");
    setReferencia("");
    setEstado("Pendiente");
    setPagado(false);
    setDestino("");
    setBody("");
    setNotasInternas("");
  };

  const handleEdit = (record) => {
    console.log("Editando registro:", record);
    setEditingRecord(record);
    setId(record.id);
    setTitle2(record.title || "");
    setDocumento2(record.documento || "");
    setTelefono2(record.telefono || "");
    setCorreoElectronico2(record.correoelectronico || "");
    setReferencia2(record.referencia || "");
    setEstado2(record.estado || "");
    setDestino2(record.destino || "");
    setBody2(record.body || "");
    setNotasInternas2(record.notasinternas || "");
    setPagado2(record.pagado || false);
    // setIsAntModalOpen(true);
    modalEdit.onOpen();
  };

  const reloadData = () => {
    console.log("🔄 Recargando datos...");
    setPending(true);
    dispatch(getNotes());
    dispatch(getDestinos());
    dispatch(getEstados());
  };

  const onChangeSwitch = (checked) => {
    setVerEtiquetas(checked);
  };


  const filteredData = React.useMemo(() => {
    if (!searchGlobal) return tableData;
    
    return tableData.filter(item =>
      // Buscar en todos los campos relevantes
      Object.keys(item).some(key => {
        const value = item[key];
        if (value && typeof value === 'string') {
          return value.toLowerCase().includes(searchGlobal.toLowerCase());
        }
        if (value && typeof value === 'number') {
          return value.toString().includes(searchGlobal);
        }
        return false;
      })
    );
  }, [tableData, searchGlobal]);

  // Buscador global component
  const GlobalSearch = () => {
    // Efecto para mantener el foco después de cada render
    useEffect(() => {
      if (searchInputRef.current) {
        searchInputRef.current.focus();
      }
    }, [searchGlobal]); // Se ejecuta cuando searchGlobal cambia

    return (
      <div style={{ marginBottom: 16, display: 'flex', gap: '8px', alignItems: 'center' }}>
        <AntInput
          ref={searchInputRef}
          placeholder="Buscar en todas las notas..."
          value={searchGlobal}
          onChange={(e) => setSearchGlobal(e.target.value)}
          style={{ width: 300 }}
          prefix={<SearchOutlined />}
          allowClear
          onKeyDown={(e) => {
            // Permitir navegación con teclado sin perder foco
            if (e.key === 'Escape') {
              setSearchGlobal('');
            }
          }}
        />
        {searchGlobal && (
          <Text type="secondary">
            {filteredData.length} de {tableData.length} resultados
          </Text>
        )}
      </div>
    );
  };

  // Función para copiar al portapapeles
  const copyToClipboard = (text) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => {
        message.success('Copiado al portapapeles');
      }).catch(() => {
        fallbackCopyToClipboard(text);
      });
    } else {
      fallbackCopyToClipboard(text);
    }
  };

  const fallbackCopyToClipboard = (text) => {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      message.success('Copiado al portapapeles');
    } catch (err) {
      message.error('Error al copiar');
    }
    document.body.removeChild(textArea);
  };


  // Ant Design Table Columns - CORREGIDAS
  const columns = [

    {
      title: 'Acciones',
      key: 'actions',
      width: 80,
      render: (_, record) => (
      <IconButton
            icon={<EditOutlined />}
            size="small"
            onClick={() => handleEdit(record)}
            aria-label="Editar nota"
          />
      ),
    },
    {
      title: 'Destino',
      dataIndex: 'destino',
      key: 'destino',
      width: 200,
      sorter: (a, b) => (a.destino || '').localeCompare(b.destino || ''),
    },
    {
      title: 'Nombre',
      dataIndex: 'title',
      key: 'title',
      width: 250,
      sorter: (a, b) => (a.title || '').localeCompare(b.title || ''),
      render: (text, record) => (
        <Tippy content={getTooltipContent(record)}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Text>{text}</Text>
            {/* {text && (
              <Button
                type="text"
                icon={<CopyOutlined />}
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  copyToClipboard(text);
                }}
              />
            )} */}
          </div>
        </Tippy>
      ),
    },
    {
      title: 'Nº Documento',
      dataIndex: 'documento',
      key: 'documento',
      width: 150,
      sorter: (a, b) => (a.documento || '').localeCompare(b.documento || ''),
      render: (text) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Text>{text}</Text>
          {/* {text && (
            <Button
              type="text"
              icon={<CopyOutlined />}
              size="small"
              onClick={() => copyToClipboard(text)}
            />
          )} */}
        </div>
      ),
    },
    {
      title: 'Teléfono',
      dataIndex: 'telefono',
      key: 'telefono',
      width: 150,
      render: (text) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <BotonWhatsapp telefono={text} vernumero={true} />
          {/* {text && (
            <Button
              type="text"
              icon={<CopyOutlined />}
              size="small"
              onClick={() => copyToClipboard(text)}
            />
          )} */}
        </div>
      ),
    },
    {
      title: 'Creado',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 140,
      render: (text) => campoFecha(text),
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    },
    {
      title: 'Modificado',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      width: 140,
      render: (text) => campoFecha(text),
      sorter: (a, b) => new Date(a.updatedAt) - new Date(b.updatedAt),
    },
    {
      title: 'Pagado',
      dataIndex: 'pagado',
      key: 'pagado',
      width: 80,
      render: (text) => <ViewChecks valor={text} />,
      sorter: (a, b) => (a.pagado ? 1 : 0) - (b.pagado ? 1 : 0),
    },
    {
      title: 'Estado',
      dataIndex: 'estado',
      key: 'estado',
      width: 120,
      render: (text, record) => tagColor(record),
      sorter: (a, b) => (a.estado || '').localeCompare(b.estado || ''),
      onCell: (record) => ({
        onDoubleClick: (e) => {
          e.stopPropagation(); // ¡IMPORTANTE! Evita que se active el doble click de la fila
          handleEstadoDoubleClick(record);
        },
        style: { 
          cursor: 'pointer',
          background: 'transparent'
        }
      }),
    },
  ];



// Componente para estado vacío
 const EmptyState = () => (
    <Card>
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          <div>
            <Text fontSize="lg" mb={2}>No hay notas disponibles</Text>
            <Text color="gray.500" mb={3}>
              {loading ? 'Cargando...' : 'No se encontraron notas en la base de datos'}
            </Text>
            <Button 
              type="primary" 
              icon={<ReloadOutlined />} 
              onClick={reloadData}
            >
              Recargar datos
            </Button>
          </div>
        }
      />
    </Card>
  );

// Función para obtener el color según el estado
  function getEstadoColor(estado) {
    if (!estado) return 'default';
    
    const estadoUpper = estado.toUpperCase();
    const colorMap = {
      'FINALIZADO': 'green',
      'PENDIENTE': 'red',
      'AVISADO': 'blue',
      'CANCELADO CLIENTE': 'gray',
      'ALBARÁN': 'purple'
    };
    
    return colorMap[estadoUpper] || 'default';
  }  

  return (
    <>
      <FloatButton 
        icon={<AddIcon fontSize={20} />}
        type="primary"
        onClick={() => {
          resetForm();
          // dispatch(getNombres());
          onOpen();
        }}
      />
      
      <Box mt={20} padding={18}>
        {/* Header con información de debug */}
        {/* <Card size="small" style={{ marginBottom: 16, background: '#f0f8ff' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <Text strong>Estado de la aplicación:</Text>
              <Text>Notas: {Array.isArray(data) ? data.length : '0'} | 
                    Destinos: {Array.isArray(datadestino) ? datadestino.length : '0'} | 
                    Estados: {Array.isArray(dataestado) ? dataestado.length : '0'}</Text>
            </div>
            <Button 
              icon={<ReloadOutlined />} 
              onClick={reloadData}
              loading={loading}
            >
              Recargar
            </Button>
          </div>
        </Card>         */}
        <Wrap>
          <WrapItem>
            <Center w='180px' h='40px'>
              {/* Optional additional button */}
            </Center>
          </WrapItem>
        </Wrap>

        {/* <SelectFiltros
          destinos={datadestino || []}
          estados={dataestado || []}
          setFiltroDestinos={setFiltroDestinos}
          setFiltroEstados={setFiltroEstados}            
        /> */}
<SelectFiltros
  destinos={datadestino || []}
  estados={dataestado || []}
  setFiltroDestinos={setFiltroDestinos}
  setFiltroEstados={setFiltroEstados}
  filtroestados={filtroestados} // <- AÑADE ESTA PROPS
  filtrodestinos={filtrodestinos} // <- AÑADE ESTA PROPS
/>        

        <GlobalSearch />

        {/* Mostrar error si existe */}
        {error && (
          <Alert status="error" mb={4}>
            <AlertIcon />
            Error al cargar las notas: {error}
          </Alert>
        )}        

        {isMobile && (
          <Space direction="vertical">
            <Switch
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
              defaultChecked
              onChange={onChangeSwitch}
            />
            <Text>Ver Etiquetas</Text>
          </Space>
        )}

        {verEtiquetas && isMobile ? (
          <Grid gap={10} w={"100%"} margin={"auto"} gridTemplateColumns="repeat(1, 1fr)">
            {tableData?.map((el) => <NoteCard key={el.id} {...el} />)}
          </Grid>
        ) : (
          <Table
            dataSource={filteredData}
            columns={columns}
            loading={loading || pending}
            onRow={(record) => ({
              onDoubleClick: () => handleRowDoubleClick(record),
              onContextMenu: (e) => handleContextMenu(e, record),
              style: { 
                cursor: 'pointer'
              }
            })}         
            expandable={{
                expandedRowRender: (record) => (
                  <Card 
                    size="small" 
                    style={{ margin: 0, background: '#f8f9fa' }}
                    bodyStyle={{ padding: '12px' }}
                  >
                    <Space direction="vertical" style={{ width: '100%' }} size="small">
                      {/* Referencia */}
                      {(record.referencia) && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <Tag color="blue" style={{ margin: 0, minWidth: '70px' }}>Referencia</Tag>
                          <Text style={{ flex: 1, margin: 0 }}>{record.referencia}</Text>
                          <Button
                            type="text"
                            icon={<CopyOutlined />}
                            size="small"
                            onClick={() => copyToClipboard(record.referencia)}
                          />
                        </div>
                      )}
                      
                      {/* Notas */}
                      {(record.body) && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <Tag color="green" style={{ margin: 0, minWidth: '70px' }}>Notas</Tag>
                          <Text style={{ flex: 1, margin: 0 }}>{record.body}</Text>
                          <Button
                            type="text"
                            icon={<CopyOutlined />}
                            size="small"
                            onClick={() => copyToClipboard(record.body)}
                          />
                        </div>
                      )}
                      
                      {/* Notas Internas */}
                      {(record.notasinternas) && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <Tag color="orange" style={{ margin: 0, minWidth: '70px' }}>Internas</Tag>
                          <Text style={{ flex: 1, margin: 0 }}>{record.notasinternas}</Text>
                          <Button
                            type="text"
                            icon={<CopyOutlined />}
                            size="small"
                            onClick={() => copyToClipboard(record.notasinternas)}
                          />
                        </div>
                      )}

                      {/* Mensaje si no hay datos */}
                      {!record.referencia && !record.body && !record.notasinternas && (
                        <Text type="secondary" style={{ textAlign: 'center' }}>
                          No hay información adicional
                        </Text>
                      )}
                    </Space>
                  </Card>
                ),
                rowExpandable: (record) => record.referencia || record.body || record.notasinternas,
                expandIcon: ({ expanded, onExpand, record }) =>
                  (record.referencia || record.body || record.notasinternas) ? (
                    <Button
                      type="text"
                      icon={expanded ? <DownOutlined /> : <RightOutlined />}
                      onClick={(e) => {
                        e.stopPropagation();
                        onExpand(record, e);
                      }}
                      size="small"
                      style={{ border: 'none', boxShadow: 'none' }}
                    />
                  ) : (
                    <div style={{ width: '32px' }}></div>
                  ),
              }}
            pagination={{
              pageSize: 100,
              showSizeChanger: true,
              pageSizeOptions: ['100', '200', '300', '400', '500'],
              showTotal: (total, range) => 
                `${range[0]}-${range[1]} de ${total} elementos`,
            }}
            scroll={{ x: 1200 }}
            size="small"
            rowKey="id"
            title={() => (
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span>Notas {Array.isArray(data) && data.length > 0 ? `(${data.length})` : ''}</span>
                {!Array.isArray(data) || data.length === 0 ? (
                  <Text type="secondary" style={{ fontSize: '12px' }}>
                    Mostrando datos de prueba
                  </Text>
                ) : null}
              </div>
            )}
            locale={{ 
              emptyText: <EmptyState />
            }}
          />
        )}

        {contextMenu.visible && (
          <>
            {/* Overlay para cerrar al hacer click fuera */}
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 999,
              }}
              onClick={handleCloseContextMenu}
            />
            
            {/* Menú contextual */}
            <div
              style={{
                position: 'fixed',
                top: contextMenu.y,
                left: contextMenu.x,
                background: 'white',
                border: '1px solid #d9d9d9',
                borderRadius: '6px',
                boxShadow: '0 3px 6px -4px rgba(0,0,0,0.12), 0 6px 16px 0 rgba(0,0,0,0.08), 0 9px 28px 8px rgba(0,0,0,0.05)',
                zIndex: 1000,
                minWidth: '150px'
              }}
            >
              <Menu mode="vertical" style={{ border: 'none' }}>
                <Menu.Item 
                  key="edit"
                  icon={<EditOutlined />}
                  onClick={() => handleEdit(contextMenu.record)}
                >
                  Editar Nota
                </Menu.Item>
                <Menu.Item 
                  key="duplicate"
                  icon={<CopyOutlined />}
                  onClick={() => duplicateNote(contextMenu.record)}
                >
                  Duplicar Nota
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item 
                  key="whatsapp"
                  icon={<WhatsAppOutlined />}
                  onClick={() => window.open(`https://wa.me/34${contextMenu.record.telefono}`, '_blank')}
                  disabled={!contextMenu.record.telefono}
                >
                  Enviar WhatsApp
                </Menu.Item>
              </Menu>
            </div>
          </>
        )}

        {/* Chakra Modal for Create */}
        <Modal
          isOpen={isOpen}
          onClose={onClose}
          size={isMobile ? "full" : "xl"}
        >
          <ModalOverlay />
          <ModalContent maxW={isMobile ? "100%" : "40%"}>
            <ModalHeader>Crear nueva nota</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <CreateNoteForm
                title={title}
                setTitle={setTitle}
                documento={documento}
                setDocumento={setDocumento}
                telefono={telefono}
                setTelefono={setTelefono}
                correoelectronico={correoelectronico}
                setCorreoElectronico={setCorreoElectronico}
                referencia={referencia}
                setReferencia={setReferencia}
                estado={estado}
                setEstado={setEstado}
                pagado={pagado}
                setPagado={setPagado}
                destino={destino}
                setDestino={setDestino}
                body={body}
                setBody={setBody}
                notasinternas={notasinternas}
                setNotasInternas={setNotasInternas}
                datadestino={datadestino}
                dataestado={dataestado}
                copyToClipboard={copyToClipboard}
              />
            </ModalBody>
            <ModalFooter>
              <ButtonChakra colorScheme="blue" mr={3} onClick={createNote}>
                Crear
              </ButtonChakra>
              <ButtonChakra onClick={onClose}>Cancelar</ButtonChakra>
            </ModalFooter>
          </ModalContent>
        </Modal>


<Modal
  isOpen={modalEdit.isOpen}
  onClose={modalEdit.onClose}
  size={isMobile ? "full" : "xl"}
>
  <ModalOverlay />
  <ModalContent maxW={isMobile ? "100%" : "40%"}>
    <ModalHeader>Editar Nota</ModalHeader>
    <ModalCloseButton />
    <ModalBody pb={6}>
      <Stack spacing={4}>
        <InputGroup>
          <InputLeftAddon width={150}>ID</InputLeftAddon>
          <Input isDisabled value={tempID} onChange={(e)=>setId(e.target.value)} size="sm"/>
        </InputGroup>

        <InputGroup>
          <InputLeftAddon width={150}>Destino</InputLeftAddon>
          <Select 
            placeholder='Selecciona Opción' 
            onChange={(e)=>setDestino2(e.target.value)}
            value={tempDestino}
            size="sm"
          >
            {datadestino?.map(c => (
              <option key={c.descripcion} value={c.descripcion}>
                {c.descripcion}
              </option>
            ))}
          </Select>
        </InputGroup>

        <InputGroup>
          <InputLeftAddon width={150}>Nombre</InputLeftAddon>
          <Input 
            value={tempTitle} 
            placeholder="Introduce el nombre" 
            onChange={(e)=>setTitle2(e.target.value)}
            size="sm"
          />
          <IconButton
            icon={<CopyIcon />}
            ml={2}
            onClick={() => copyToClipboard(tempTitle)}
            isDisabled={!tempTitle}
            aria-label="Copiar nombre"
            size="sm"
            style={{width: '80px', }}
          />
        </InputGroup>

        <InputGroup>
          <InputLeftAddon width={150}>Nº Documento</InputLeftAddon>
          <Input 
            value={tempDocumento} 
            placeholder="Introduce el nº documento" 
            onChange={(e)=>setDocumento2(e.target.value)}
            size="sm"
          />
          <IconButton
            icon={<CopyIcon />}
            ml={2}
            onClick={() => copyToClipboard(tempDocumento)}
            isDisabled={!tempDocumento}
            aria-label="Copiar documento"
            size="sm"
            style={{width: '80px', }}
          />
        </InputGroup>

        <InputGroup>
          <InputLeftAddon width={150}>Teléfono</InputLeftAddon>
          <Input 
            value={tempTelefono} 
            placeholder="Introduce el teléfono" 
            onChange={(e)=>setTelefono2(e.target.value)}
            size="sm"
          />
          <IconButton
            icon={<CopyIcon />}
            ml={2}
            onClick={() => copyToClipboard(tempTelefono)}
            isDisabled={!tempTelefono}
            aria-label="Copiar teléfono"
            size="sm"
            style={{width: '80px', }}
          />
          <BotonWhatsapp vernumero={false} telefono={tempTelefono} />
        </InputGroup>

        <InputGroup>
          <InputLeftAddon width={150}>Correo Electrónico</InputLeftAddon>
          <Input 
            value={tempCorreoElectronico} 
            placeholder="Introduce el correo electrónico" 
            onChange={(e)=>setCorreoElectronico2(e.target.value)}
            size="sm"
          />
          <IconButton
            icon={<CopyIcon />}
            ml={2}
            onClick={() => copyToClipboard(tempCorreoElectronico)}
            isDisabled={!tempCorreoElectronico}
            aria-label="Copiar correo"
            size="sm"
            style={{width: '80px', }}
          />
        </InputGroup>

        <InputGroup>
          <InputLeftAddon width={150}>Referencia</InputLeftAddon>
          <Input 
            value={tempReferencia} 
            placeholder="Introduce la referencia" 
            onChange={(e)=>setReferencia2(e.target.value)}
            size="sm"
          />
          <IconButton
            icon={<CopyIcon />}
            ml={2}
            onClick={() => copyToClipboard(tempReferencia)}
            isDisabled={!tempReferencia}
            aria-label="Copiar referencia"
            size="sm"
            style={{width: '80px', }}
          />
        </InputGroup>

        <InputGroup>
          <InputLeftAddon width={150}>Estado</InputLeftAddon>
          <Select 
            placeholder='Selecciona Opción' 
            onChange={(e)=>setEstado2(e.target.value)}
            value={tempEstado}
            size="sm"
          >
            {dataestado?.map(c => (
              <option key={c.descripcion} value={c.descripcion}>
                {c.descripcion}
              </option>
            ))}
          </Select>
        </InputGroup>

        <InputGroup>
          <InputLeftAddon width={150}>Pagado</InputLeftAddon>
          <BotonPagado valor={tempPagado} setPagado2={setPagado2} />
        </InputGroup>

        <InputGroup alignItems="flex-start">
          <InputLeftAddon width={150} height="auto">Notas</InputLeftAddon>
          <Textarea 
            value={tempBody} 
            placeholder='Introduce notas' 
            onChange={(e)=>setBody2(e.target.value)}
            size="sm"
          />
          <IconButton
            icon={<CopyIcon />}
            ml={2}
            mt={1}
            onClick={() => copyToClipboard(tempBody)}
            isDisabled={!tempBody}
            aria-label="Copiar notas"
            size="sm"
          />
        </InputGroup>

        <InputGroup alignItems="flex-start">
          <InputLeftAddon width={150} height="auto">Notas Internas</InputLeftAddon>
          <Textarea 
            value={tempNotasInternas} 
            placeholder='Introduce notas internas' 
            onChange={(e)=>setNotasInternas2(e.target.value)}
            size="sm"
          />
          <IconButton
            icon={<CopyIcon />}
            ml={2}
            mt={1}
            onClick={() => copyToClipboard(tempNotasInternas)}
            isDisabled={!tempNotasInternas}
            aria-label="Copiar notas internas"
            size="sm"
          />
        </InputGroup>
      </Stack>
    </ModalBody>

    <ModalFooter>
      <ButtonChakra colorScheme="blue" mr={3} onClick={updateNote}>
        Guardar
      </ButtonChakra>
      <ButtonChakra onClick={modalEdit.onClose}>Cancelar</ButtonChakra>
    </ModalFooter>
  </ModalContent>
</Modal>


<AntModal
  title="Cambiar Estado"
  open={doubleClickModal}
  onOk={updateEstado}
  onCancel={() => setDoubleClickModal(false)}
  width={400}
  okText="Guardar"
  cancelText="Cancelar"
>
  {selectedNote && (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Text strong>Nota seleccionada:</Text>
        <div style={{ background: '#f5f5f5', padding: '8px', borderRadius: '4px', marginTop: '8px' }}>
          <Text><strong>Nombre:</strong> {selectedNote.title}</Text>
          <br />
          <Text><strong>Documento:</strong> {selectedNote.documento}</Text>
          <br />
          <Text><strong>Estado actual:</strong> 
            <Tag color={getEstadoColor(selectedNote.estado)} style={{ marginLeft: '8px' }}>
              {selectedNote.estado}
            </Tag>
          </Text>
        </div>
      </div>
      
      <Form layout="vertical">
        <Form.Item label="Nuevo Estado">
          <AntSelect
            value={newEstado}
            onChange={setNewEstado}
            placeholder="Selecciona un estado"
            style={{ width: '100%' }}
          >
            {dataestado?.map(estado => (
              <Option key={estado.descripcion} value={estado.descripcion}>
                <Tag color={getEstadoColor(estado.descripcion)}>
                  {estado.descripcion}
                </Tag>
              </Option>
            ))}
          </AntSelect>
        </Form.Item>
      </Form>
    </div>
  )}
</AntModal>

{/* Ant Design Modal for Edit */}
<AntModal
  title="Editar Nota"
  open={isAntModalOpen}
  onOk={updateNote}
  onCancel={() => setIsAntModalOpen(false)}
  width={isMobile ? "90%" : "500px"} // Más estrecho
  okText="Guardar"
  cancelText="Cancelar"
  style={{ top: 20 }} // Más cerca del top
>
  <Form layout="vertical" size="small">
    <Form.Item label="ID">
      <AntInput value={tempID} disabled size="small" />
    </Form.Item>

    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
      <Form.Item label="Destino">
        <AntSelect
          value={tempDestino}
          onChange={setDestino2}
          placeholder="Destino"
          size="small"
        >
          {datadestino?.map(c => (
            <Option key={c.descripcion} value={c.descripcion}>
              {c.descripcion}
            </Option>
          ))}
        </AntSelect>
      </Form.Item>

      <Form.Item label="Estado">
        <AntSelect
          value={tempEstado}
          onChange={setEstado2}
          placeholder="Estado"
          size="small"
        >
          {dataestado?.map(c => (
            <Option key={c.descripcion} value={c.descripcion}>
              {c.descripcion}
            </Option>
          ))}
        </AntSelect>
      </Form.Item>
    </div>

    <Form.Item label="Nombre">
      <Space.Compact style={{ width: '100%' }}>
        <AntInput
          value={tempTitle}
          onChange={(e) => setTitle2(e.target.value)}
          placeholder="Nombre"
          size="small"
        />
        <Button
          icon={<CopyOutlined />}
          onClick={() => copyToClipboard(tempTitle)}
          disabled={!tempTitle}
          size="small"
        />
      </Space.Compact>
    </Form.Item>

    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
      <Form.Item label="Documento">
        <Space.Compact style={{ width: '100%' }}>
          <AntInput
            value={tempDocumento}
            onChange={(e) => setDocumento2(e.target.value)}
            placeholder="Documento"
            size="small"
          />
          <Button
            icon={<CopyOutlined />}
            onClick={() => copyToClipboard(tempDocumento)}
            disabled={!tempDocumento}
            size="small"
          />
        </Space.Compact>
      </Form.Item>

      <Form.Item label="Teléfono">
        <Space.Compact style={{ width: '100%' }}>
          <AntInput
            value={tempTelefono}
            onChange={(e) => setTelefono2(e.target.value)}
            placeholder="Teléfono"
            size="small"
          />
          <Button
            icon={<CopyOutlined />}
            onClick={() => copyToClipboard(tempTelefono)}
            disabled={!tempTelefono}
            size="small"
          />
          <BotonWhatsapp telefono={tempTelefono} vernumero={false} />
        </Space.Compact>
      </Form.Item>
    </div>

    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
      <Form.Item label="Correo Electrónico">
        <Space.Compact style={{ width: '100%' }}>
          <AntInput
            value={tempCorreoElectronico}
            onChange={(e) => setCorreoElectronico2(e.target.value)}
            placeholder="Correo"
            size="small"
          />
          <Button
            icon={<CopyOutlined />}
            onClick={() => copyToClipboard(tempCorreoElectronico)}
            disabled={!tempCorreoElectronico}
            size="small"
          />
        </Space.Compact>
      </Form.Item>

      <Form.Item label="Referencia">
        <Space.Compact style={{ width: '100%' }}>
          <AntInput
            value={tempReferencia}
            onChange={(e) => setReferencia2(e.target.value)}
            placeholder="Referencia"
            size="small"
          />
          <Button
            icon={<CopyOutlined />}
            onClick={() => copyToClipboard(tempReferencia)}
            disabled={!tempReferencia}
            size="small"
          />
        </Space.Compact>
      </Form.Item>
    </div>

    <Form.Item label="Pagado">
      <BotonPagado valor={tempPagado} setPagado2={setPagado2} />
    </Form.Item>

    <Form.Item label="Notas">
      <div style={{ display: 'flex', gap: '8px' }}>
        <AntTextArea
          value={tempBody}
          onChange={(e) => setBody2(e.target.value)}
          placeholder="Notas"
          style={{ flex: 1 }}
          rows={2} // Menos alto
          size="small"
        />
        <Button
          icon={<CopyOutlined />}
          onClick={() => copyToClipboard(tempBody)}
          disabled={!tempBody}
          size="small"
        />
      </div>
    </Form.Item>

    <Form.Item label="Notas Internas">
      <div style={{ display: 'flex', gap: '8px' }}>
        <AntTextArea
          value={tempNotasInternas}
          onChange={(e) => setNotasInternas2(e.target.value)}
          placeholder="Notas internas"
          style={{ flex: 1 }}
          rows={2} // Menos alto
          size="small"
        />
        <Button
          icon={<CopyOutlined />}
          onClick={() => copyToClipboard(tempNotasInternas)}
          disabled={!tempNotasInternas}
          size="small"
        />
      </div>
    </Form.Item>
  </Form>
</AntModal>

        <Toaster />
      </Box>
    </>
  );
}

// Componente para inputs con botón de copiar
const InputWithCopy = ({ value, onChange, placeholder, leftAddon, copyToClipboard, ...props }) => (
  <InputGroup>
    <InputLeftAddon width={150}>{leftAddon}</InputLeftAddon>
    <Input 
      value={value} 
      placeholder={placeholder} 
      onChange={onChange}
      {...props}
    />
    <IconButton
      icon={<CopyIcon />}
      ml={2}
      onClick={() => copyToClipboard(value)}
      isDisabled={!value}
      aria-label="Copiar"
    />
  </InputGroup>
);

// Componente para Textarea con botón de copiar
const TextareaWithCopy = ({ value, onChange, placeholder, leftAddon, copyToClipboard, ...props }) => (
  <InputGroup alignItems="flex-start">
    <InputLeftAddon width={150} height="auto">{leftAddon}</InputLeftAddon>
    <Textarea 
      value={value} 
      placeholder={placeholder} 
      onChange={onChange}
      {...props}
    />
    <IconButton
      icon={<CopyIcon />}
      ml={2}
      mt={1}
      onClick={() => copyToClipboard(value)}
      isDisabled={!value}
      aria-label="Copiar"
    />
  </InputGroup>
);

// Componente Ant Design Input con botón de copiar
const AntInputWithCopy = ({ value, onChange, placeholder, label, copyToClipboard, ...props }) => (
  <Form.Item label={label}>
    <Space.Compact style={{ width: '100%' }}>
      <AntInput
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        {...props}
      />
      <Button
        icon={<CopyOutlined />}
        onClick={() => copyToClipboard(value)}
        disabled={!value}
      />
    </Space.Compact>
  </Form.Item>
);

// Componente Ant Design TextArea con botón de copiar
const AntTextAreaWithCopy = ({ value, onChange, placeholder, label, copyToClipboard, ...props }) => (
  <Form.Item label={label}>
    <div style={{ display: 'flex', gap: '8px' }}>
      <AntTextArea
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={{ flex: 1 }}
        rows={3}
        {...props}
      />
      <Button
        icon={<CopyOutlined />}
        onClick={() => copyToClipboard(value)}
        disabled={!value}
      />
    </div>
  </Form.Item>
);

function CreateNoteForm(props) {
  const {
    title, setTitle,
    documento, setDocumento,
    telefono, setTelefono,
    correoelectronico, setCorreoElectronico,
    referencia, setReferencia,
    estado, setEstado,
    pagado, setPagado,
    destino, setDestino,
    body, setBody,
    notasinternas, setNotasInternas,
    datadestino,
    dataestado,
    copyToClipboard
  } = props;

  return (
    <Stack spacing={4}>
      <InputGroup>
        <InputLeftAddon width={150}>Destino</InputLeftAddon>
        <Select 
          placeholder='Selecciona Opción' 
          onChange={(e) => setDestino(e.target.value)}
          value={destino}
        >
          {datadestino?.map(c => (
            <option key={c.descripcion} value={c.descripcion}>
              {c.descripcion}
            </option>
          ))}
        </Select>
      </InputGroup>

      <InputWithCopy
        leftAddon="Nombre"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        placeholder="Introduce el nombre"
        copyToClipboard={copyToClipboard}
      />

      <InputWithCopy
        leftAddon="Nº Documento"
        value={documento}
        onChange={(e) => setDocumento(e.target.value)}
        placeholder="Introduce el nº documento"
        copyToClipboard={copyToClipboard}
      />

      <InputWithCopy
        leftAddon="Teléfono"
        value={telefono}
        onChange={(e) => setTelefono(e.target.value)}
        placeholder="Introduce el teléfono"
        copyToClipboard={copyToClipboard}
      />

      <InputWithCopy
        leftAddon="Correo Electrónico"
        value={correoelectronico}
        onChange={(e) => setCorreoElectronico(e.target.value)}
        placeholder="Introduce el correo electrónico"
        copyToClipboard={copyToClipboard}
      />

      <InputWithCopy
        leftAddon="Referencia"
        value={referencia}
        onChange={(e) => setReferencia(e.target.value)}
        placeholder="Introduce la referencia"
        copyToClipboard={copyToClipboard}
      />

      <InputGroup>
        <InputLeftAddon width={150}>Estado</InputLeftAddon>
        <Select 
          placeholder='Selecciona Opción' 
          onChange={(e) => setEstado(e.target.value)} 
          value={estado}
        >
          {dataestado?.map(c => (
            <option key={c.descripcion} value={c.descripcion}>
              {c.descripcion}
            </option>
          ))}
        </Select>
      </InputGroup>

      <InputGroup>
        <InputLeftAddon width={150}>Pagado</InputLeftAddon>
        <BotonPagado valor={pagado} setPagado2={setPagado} />
      </InputGroup>

      <TextareaWithCopy
        leftAddon="Notas"
        value={body}
        onChange={(e) => setBody(e.target.value)}
        placeholder='Introduce notas'
        copyToClipboard={copyToClipboard}
      />

      <TextareaWithCopy
        leftAddon="Notas Internas"
        value={notasinternas}
        onChange={(e) => setNotasInternas(e.target.value)}
        placeholder='Introduce notas internas'
        copyToClipboard={copyToClipboard}
      />
    </Stack>
  );
}

function EditNoteForm(props) {
  const {
    tempID,
    tempTitle, setTitle2,
    tempDocumento, setDocumento2,
    tempTelefono, setTelefono2,
    tempCorreoElectronico, setCorreoElectronico2,
    tempReferencia, setReferencia2,
    tempEstado, setEstado2,
    tempDestino, setDestino2,
    tempBody, setBody2,
    tempNotasInternas, setNotasInternas2,
    tempPagado, setPagado2,
    datadestino,
    dataestado,
    copyToClipboard
  } = props;

  return (
    <Form layout="vertical">
      <Form.Item label="ID">
        <AntInput value={tempID} disabled />
      </Form.Item>

      <Form.Item label="Destino">
        <AntSelect
          value={tempDestino}
          onChange={setDestino2}
          placeholder="Selecciona destino"
        >
          {datadestino?.map(c => (
            <Option key={c.descripcion} value={c.descripcion}>
              {c.descripcion}
            </Option>
          ))}
        </AntSelect>
      </Form.Item>

      <AntInputWithCopy
        label="Nombre"
        value={tempTitle}
        onChange={(e) => setTitle2(e.target.value)}
        placeholder="Introduce el nombre"
        copyToClipboard={copyToClipboard}
      />

      <AntInputWithCopy
        label="Documento"
        value={tempDocumento}
        onChange={(e) => setDocumento2(e.target.value)}
        placeholder="Introduce el nº documento"
        copyToClipboard={copyToClipboard}
      />

      <Form.Item label="Teléfono">
        <Space.Compact style={{ width: '100%' }}>
          <AntInput
            value={tempTelefono}
            onChange={(e) => setTelefono2(e.target.value)}
            placeholder="Introduce el teléfono"
          />
          <Button
            icon={<CopyOutlined />}
            onClick={() => copyToClipboard(tempTelefono)}
            disabled={!tempTelefono}
          />
          <BotonWhatsapp telefono={tempTelefono} vernumero={false} />
        </Space.Compact>
      </Form.Item>

      <AntInputWithCopy
        label="Correo Electrónico"
        value={tempCorreoElectronico}
        onChange={(e) => setCorreoElectronico2(e.target.value)}
        placeholder="Introduce el correo electrónico"
        copyToClipboard={copyToClipboard}
      />

      <AntInputWithCopy
        label="Referencia"
        value={tempReferencia}
        onChange={(e) => setReferencia2(e.target.value)}
        placeholder="Introduce la referencia"
        copyToClipboard={copyToClipboard}
      />

      <Form.Item label="Estado">
        <AntSelect
          value={tempEstado}
          onChange={setEstado2}
          placeholder="Selecciona estado"
        >
          {dataestado?.map(c => (
            <Option key={c.descripcion} value={c.descripcion}>
              {c.descripcion}
            </Option>
          ))}
        </AntSelect>
      </Form.Item>

      <Form.Item label="Pagado">
        <BotonPagado valor={tempPagado} setPagado2={setPagado2} />
      </Form.Item>

      <AntTextAreaWithCopy
        label="Notas"
        value={tempBody}
        onChange={(e) => setBody2(e.target.value)}
        placeholder="Introduce notas"
        copyToClipboard={copyToClipboard}
      />

      <AntTextAreaWithCopy
        label="Notas Internas"
        value={tempNotasInternas}
        onChange={(e) => setNotasInternas2(e.target.value)}
        placeholder="Introduce notas internas"
        copyToClipboard={copyToClipboard}
      />
    </Form>
  );
}

// Helper functions (sin cambios)
function campoFecha(data) {
  if (!data) return '-';
  const moment = require('moment');
  return moment(data).format("DD/MM/YYYY HH:mm");
}

function tagColor(row) {
  const estado = row.estado?.toUpperCase();
  let color = 'default';

  const colorMap = {
    'FINALIZADO': 'success',
    'PENDIENTE': 'error',
    'AVISADO': 'processing',
    'CANCELADO CLIENTE': 'default',
    'ALBARÁN': 'blue'
  };

  color = colorMap[estado] || 'default';

  return <AntTag color={color}>{row.estado}</AntTag>;
}

function ViewChecks({ valor }) {
  return valor ? <CheckOutlined style={{ color: '#52c41a' }} /> : <CloseOutlined style={{ color: '#ff4d4f' }} />;  
}

function BotonPagado({ valor, setPagado2 }) {
  return (
    <Switch
      checked={valor}
      onChange={setPagado2}
      // checkedChildren={<FaCheck />}
      // unCheckedChildren={<FaTimes />}
      style={{ 
        backgroundColor: valor ? '#38A169' : '#E53E3E',marginTop:'5px'
      }}
    />
  );
}

function BotonWhatsapp({ telefono, vernumero }) {
  const link = `https://wa.me/34${telefono}`;
  
  return (
    <Button
      type="primary"
      icon={<WhatsAppOutlined />}
      href={link}
      target="_blank"
      style={{ 
        backgroundColor: '#25D366',
        borderColor: '#25D366',
        width:'120px',
        marginLeft:'10px'
      }}
    >
      {vernumero ? telefono : ''}
    </Button>
  );
}

function getTooltipContent(row) {
  let datos = row.body || '';
  
  if (row.notasinternas && row.notasinternas.length > 5) {
    datos = `${datos}\n\n*************************\n\n${row.notasinternas}`;
  }
  
  return datos;
}